module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "fm_author"
    }
  }), _c('a', {
    attrs: {
      "id": "page_viii"
    }
  }, [_vm._v("David Lehman was born in New York City in 1948. Educated at Stuyvesant High School and Columbia University, he spent two years as a Kellett Fellow at Clare College, Cambridge, and worked as Lionel Trilling’s research assistant upon his return from England. He is the author of eight books of poetry, including "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Yeshiva Boys")]), _vm._v(" (2009), "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("When a Woman Loves a Man")]), _vm._v(" (2005), "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("The Daily Mirror")]), _vm._v(" (2000), and "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Valentine Place")]), _vm._v(" (1996). His "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("New and Selected Poems")]), _vm._v(" is forthcoming from Scribner. He is the editor of "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("The Oxford Book of American Poetry")]), _vm._v(" (Oxford, 2006) and "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Great American Prose Poems: From Poe to the Present")]), _vm._v(" (Scribner, 2003). "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("A Fine Romance: Jewish Songwriters, American Songs")]), _vm._v(" (Nextbook/Schocken), the most recent of his six nonfiction books, won the Deems Taylor Award from the American Society of Composers, Authors, and Publishers (ASCAP) in 2010. Among Lehman’s other books are a study in detective novels ("), _c('span', {
    staticClass: "txit"
  }, [_vm._v("The Perfect Murder")]), _vm._v("), a group portrait of the New York School of poets ("), _c('span', {
    staticClass: "txit"
  }, [_vm._v("The Last Avant-Garde")]), _vm._v("), and an account of the scandal sparked by the revelation that a Yale University eminence had written for a pro-Nazi newspaper in his native Belgium in World War II ("), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Signs of the Times: Deconstruction and the Fall of Paul de Man")]), _vm._v("). He teaches in the graduate writing program of The New School and lives in New York City and in Ithaca, New York.")])]), _c('a', {
    attrs: {
      "id": "page_viii"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-33334481","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/fm_author.vue
// module id = 72
// module chunks = 0